module.exports = __webpack_public_path__ + "img/corp_web.36789c04.png";